export interface MercantilEncryptPaymentBody {
  amount: string;
  customerName: string;
  returnUrl: string;
  merchantId: string;
  contract: {
    contractNumber: string;
    contractDate: string;
  };
  trxType: string;
  currency: string;
  paymentConcepts: string[];
  paymentProcessDto: {
    paymentOrdersId: string;
    serviceCenterId: string;
    originId: string;
    ivaAmount: number;
    islrAmount: number;
    handlesTaxWithholdings: boolean;
    typeOfOriginPayment: number;
    numberOfRechargesToProcess: number | null;
    amountOfTime: number | null;
    paymentProcessType: number;
  };
}
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MercantilPaymentService {
  constructor(private http: HttpClient) {}

  /**
   * Calls GET /api/v1/settings-mobile/{ServiceCenterId}/{Banks}
   * @param serviceCenterId string
   * @param banks number (always 3)
   */
  getSettingsMobile(
    serviceCenterId: string,
    banks: number = 3
  ): Observable<any> {
    const url = `${environment.api}/api/v1/settings-mobile/${serviceCenterId}/${banks}`;
    console.log('[MercantilPaymentService] GET settings-mobile:', {
      url,
      serviceCenterId,
      banks,
    });
    return this.http.get<any>(url);
  }
  /**
   * Calls POST /api/v1/integraciones/mercantil/encrypt
   * @param body Object matching the required schema
   */
  encryptPayment(body: MercantilEncryptPaymentBody): Observable<any> {
    const url = `${environment.api}/api/v1/integraciones/mercantil/encrypt`;
    console.log('[MercantilPaymentService] POST encrypt:', { url, body });
    return this.http.post<any>(url, body);
  }
}
